import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  BlazeExternalContext,
  SubjectModalContext,
  ThemeContext,
  UserContext,
} from "../../../context";
import { Link, useLocation } from "react-router-dom";
import { VideoCameraRounded } from "../../../assets";
import HomeIcon from "@material-ui/icons/HomeRounded";
import SlideshowIcon from "@material-ui/icons/Slideshow";
import { blazeUnreadMesagesNotification } from "../../../database";
import nounBook from "../../../assets/images/classroom/noun_Book_5020.svg";
import tutorLogo from "../../../assets/images/auth/pustack_tutor_white_logo.png";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";

import "./style.scss";
import { useMediaQuery } from "react-responsive";
import { Add } from "@material-ui/icons";
import maths from "../../../assets/subjects/maths.svg";
import mathsBg from "../../../assets/subjects/mathsBg.svg";
import { db, rdb } from "../../../firebase_config";
import axios from "axios";
import {
  fetchStoryItems,
  storyEventNames,
} from "../../../context/global/SubjectModal";
import Tooltip from "@material-ui/core/Tooltip";
import { showSnackbar } from "../../../helpers";

const assetForSubjects = {
  maths: {
    bgImage: require("../../../assets/subjects/mathsBg.svg"),
    image: require("../../../assets/subjects/maths.svg"),
  },
  biology: {
    bgImage: require("../../../assets/subjects/biologyBg.svg"),
    image: require("../../../assets/subjects/biology.svg"),
  },
  chemistry: {
    bgImage: require("../../../assets/subjects/chemistryBg.svg"),
    image: require("../../../assets/subjects/chemistry.svg"),
  },
  civics: {
    bgImage: require("../../../assets/subjects/civicsBg.svg"),
    image: require("../../../assets/subjects/civics.svg"),
  },
  economics: {
    bgImage: require("../../../assets/subjects/economicsBg.svg"),
    image: require("../../../assets/subjects/economics.svg"),
  },
  english: {
    bgImage: require("../../../assets/subjects/readingBg.svg"),
    image: require("../../../assets/subjects/english.svg"),
  },
  grammar: {
    bgImage: require("../../../assets/subjects/grammarBg.svg"),
    image: require("../../../assets/subjects/grammar.svg"),
  },
  geography: {
    bgImage: require("../../../assets/subjects/geographyBg.svg"),
    image: require("../../../assets/subjects/geography.svg"),
  },
  history: {
    bgImage: require("../../../assets/subjects/historyBg.svg"),
    image: require("../../../assets/subjects/history.svg"),
  },
  literature: {
    bgImage: require("../../../assets/subjects/literatureBg.svg"),
    image: require("../../../assets/subjects/literature.svg"),
  },
  physics: {
    bgImage: require("../../../assets/subjects/physicsBg.svg"),
    image: require("../../../assets/subjects/physics.svg"),
  },
  reading: {
    bgImage: require("../../../assets/subjects/readingBg.svg"),
    image: require("../../../assets/subjects/reading.svg"),
  },
  writing: {
    bgImage: require("../../../assets/subjects/writingBg.svg"),
    image: require("../../../assets/subjects/writing.svg"),
  },
};

export function GradientSVG() {
  const idCSS = "hello";
  const gradientTransform = `rotate(90)`;
  return (
    <svg style={{ height: 0 }}>
      <defs>
        <linearGradient id={idCSS} gradientTransform={gradientTransform}>
          <stop offset="16.29%" stopColor="#9C27B0" />
          <stop offset="41.56%" stopColor="#E91E63" />
          <stop offset="79.56%" stopColor="#FF9800" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const story = {
  user_profile_pic:
    "https://firebasestorage.googleapis.com/v0/b/avian-display-193502.appspot.com/o/users%2Fuser_profile%2Fdefault%2Fimage.jpg?alt=media&token=da277c04-0b39-49a3-8b90-4d6e93129a93",
  uid: "r0QO4lKPNCQJnrc0OTyLKEx6CuO2",
  grade_id: "class_9",
  user_name: "Ronak",
  item_background_image: "images/subjects/chemistry.svg",
  item_name: "Science",
  id: "vFiuIbvTtxcfGbxOAhUb",
};
const subjectDirPath = "../../../assets/subjects";

export function fetchAssetsOfChapter(str) {
  const fileName = str.split("/").reverse()[0];
  const subjectName = fileName.split(".")[0];

  return assetForSubjects[subjectName];
}

export const STORY_STATUS = {
  LOADING: "loading",
  IS_TRANSCODING: "isTranscoding",
  IS_UPLOADING: "isUploading",
  LOADED: "loaded",
};

function StoryItemShimmer() {
  return (
    <div className="flex-1 flex flex-col animate-pulse items-center justify-center cursor-pointer">
      <div className="app-shimmer bg-black md:bg-white dark:bg-white bg-opacity-10 aspect-square w-full p-0 rounded-full" />
      <span className="app-shimmer bg-black md:bg-white dark:bg-white bg-opacity-10 text-xs mt-1 rounded pointer-events-none">
        English
      </span>
    </div>
  );
}

export function StoryItem({ story, handleClick, big }) {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [, setSelectedStoryIndex] =
    useContext(SubjectModalContext).selectedStoryIndex;
  const [stories, setStories] = useContext(SubjectModalContext).stories;
  const storyEventRef = useContext(SubjectModalContext).storyEventRef;
  const fetched = useRef(false);
  const [isTranscoding, setIsTranscoding] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [status, setStatus] = useState(STORY_STATUS.LOADED);
  const [user] = useContext(UserContext).user;
  const [unWatched, setUnWatched] = useState(true);
  const isSmallScreen = useMediaQuery({ query: "(max-width: 500px)" });
  const [isDark] = useContext(ThemeContext).theme;

  useEffect(() => {
    function onUpdate(snapshot) {
      const story = snapshot.val() ? snapshot.val() : {};
      const keys = Object.keys(story?.cumulative_views ?? {});
      setUnWatched(!keys.includes(user.uid));

      const status = story?.transcoding_status?.status;

      if (!isNaN(status) && status !== 3) {
        setStatus(STORY_STATUS.IS_TRANSCODING);
      } else {
        setStatus(STORY_STATUS.LOADED);
      }
    }
    rdb.ref("stories/collections").child(story.id).on("value", onUpdate);

    return () => {
      rdb.ref("stories/collections").child(story.id).off("value", onUpdate);
    };
  }, [story.id]);

  useEffect(() => {
    if (fetched.current) return;
    if (story.items && story.items.length > 0) return;

    setStatus(STORY_STATUS.LOADING);

    fetchStoryItems(story.id)
      .then((items) => {
        console.log("Setting story - ");
        setStories((stories) => {
          const _stories = [...stories];
          const _storyObjectIndex = _stories.findIndex(
            (c) => c.id === story.id
          );
          const _storyObject = _stories[_storyObjectIndex];
          _stories.splice(_storyObjectIndex, 1, {
            ..._storyObject,
            fetched: true,
            items: items,
          });
          return _stories;
        });
        setStatus(STORY_STATUS.LOADED);
        fetched.current = true;
      })
      .catch((err) => {
        console.log("err - ", err);
        fetched.current = false;
      });
  }, [story.id, story.items, user.uid]);

  useEffect(() => {
    function handleUploadStoryProgress({ detail }) {
      if (detail.storyName !== story.item_name) return;
      console.log(
        "detail from story progress - ",
        detail,
        detail.status === STORY_STATUS.IS_TRANSCODING,
        story.id
      );
      if (detail.status === STORY_STATUS.IS_UPLOADING) {
        setStatus(STORY_STATUS.IS_UPLOADING);
        setProgress(detail.progress);
      } else if (detail.status === STORY_STATUS.IS_TRANSCODING) {
        rdb
          .ref(`stories/collections/${detail.storyId}/cumulative_views`)
          .remove();
        rdb
          .ref(
            `stories/collections/${detail.storyId}/transcoding_status/status`
          )
          .set(0);
        setStatus(STORY_STATUS.IS_TRANSCODING);
      } else if (detail.status === STORY_STATUS.LOADED) {
        setStatus(STORY_STATUS.LOADED);
      } else if (detail.status === STORY_STATUS.LOADING) {
        setStatus(STORY_STATUS.LOADING);
      }
    }

    function handleStoryViewed({ detail }) {
      if (detail.storyId !== story.id) return;
      setUnWatched(false);
      rdb
        .ref("stories/collections")
        .child(story.id)
        .child("cumulative_views")
        .child(user.uid)
        .set({
          watched_on: new Date().toISOString(),
        });
    }
    storyEventRef.current.addEventListener(
      storyEventNames.uploadStoryProgress,
      handleUploadStoryProgress
    );
    storyEventRef.current.addEventListener(
      storyEventNames.storyViewed,
      handleStoryViewed
    );

    return () => {
      storyEventRef.current.removeEventListener(
        storyEventNames.uploadStoryProgress,
        handleUploadStoryProgress
      );
      storyEventRef.current.removeEventListener(
        storyEventNames.storyViewed,
        handleStoryViewed
      );
    };
  }, [storyEventRef, story.item_name, story.id, user.uid]);

  async function onClick() {
    if (
      [
        STORY_STATUS.LOADING,
        STORY_STATUS.IS_TRANSCODING,
        STORY_STATUS.IS_UPLOADING,
      ].includes(status)
    )
      return showSnackbar("Please wait for the story to upload", "warning");
    setStatus(STORY_STATUS.LOADING);
    if (unWatched) {
      setSelectedStoryIndex((c) => ({ ...c, [story.id]: 0 }));
    }
    await handleClick(story.id);
    storyEventRef.current.dispatchEvent(storyEventNames.storyViewed, {
      storyId: story.id,
    });
    setStatus(STORY_STATUS.LOADED);
  }

  const statusMessages = {
    loading: "Fetching Story",
    isTranscoding: "Transcoding Story",
    isUploading: "Uploading Story",
    loaded: story.item_name,
  };

  console.log("progress - ", progress);

  return (
    <Tooltip title={statusMessages[status]} placement={"bottom"}>
      <div
        className="flex-grow-1 flex-shrink-0 flex flex-col items-center justify-center cursor-pointer"
        onClick={onClick}
      >
        <div
          className="aspect-square w-[--size] h-[--size] p-0 rounded-full"
          style={{
            // background: 'conic-gradient(#9C27B0, #E91E63, #FF9800, #9C27B0)'
            "--size": big ? "110px" : "60px",
          }}
        >
          <GradientSVG />
          <CircularProgressbarWithChildren
            strokeWidth={4}
            value={
              status === STORY_STATUS.IS_UPLOADING
                ? +progress
                : status === STORY_STATUS.LOADED && !unWatched
                ? 0
                : 100
            }
            classes={{
              root: [
                STORY_STATUS.IS_TRANSCODING,
                STORY_STATUS.LOADING,
              ].includes(status)
                ? "animate-spin"
                : "",
            }}
            styles={{
              path: { stroke: `url(#hello)`, height: "100%" },
              trail: {
                stroke: isSmallScreen
                  ? isDark
                    ? "rgba(255,255,255,0.15)"
                    : "rgba(0,0,0,0.15)"
                  : "rgba(255,255,255,0.35)",
              },
            }}
          >
            <div className="rounded-full bg-[transparent] p-1.5">
              <div className="bg-gray-700 flex relative justify-center items-center  rounded-full overflow-hidden">
                <img
                  className="w-full h-full object-cover"
                  src={
                    fetchAssetsOfChapter(story.item_background_image).bgImage
                  }
                  alt=""
                />
                <img
                  className="w-[50%] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                  src={fetchAssetsOfChapter(story.item_background_image).image}
                  alt=""
                />
              </div>
            </div>
          </CircularProgressbarWithChildren>
        </div>
        <span
          className={
            "mt-1 text-opacity-80 " +
            (big ? "text-[26px] " : "text-sm ") +
            (isSmallScreen ? "text-gray-900 dark:text-white" : "text-white")
          }
        >
          {story.item_name}
        </span>
      </div>
    </Tooltip>
  );
}

export const StoryListItem = ({ story, handleClick }) => {
  const [_stories] = useContext(SubjectModalContext).stories;
  const [, setSelectedStoryIndex] =
    useContext(SubjectModalContext).selectedStoryIndex;
  const [, setShowStoryModal] = useContext(SubjectModalContext).showStoryModal;
  const [, setUploadStoryFile] =
    useContext(SubjectModalContext).uploadStoryFile;
  const [, setCursor] = useContext(SubjectModalContext).storyCursor;
  const isSmallScreen = useMediaQuery({ query: "(max-width: 500px)" });

  const stories = useMemo(() => {
    return _stories?.filter((c) => !c.fetched || c.items?.length > 0);
  }, [_stories]);

  const handleStoryItemClick = useCallback(
    async (storyId) => {
      // const items = await fetchStoryItems(storyId);
      const itemIndex = stories.findIndex((c) => c.id === storyId);
      setSelectedStoryIndex(itemIndex);
      setCursor(itemIndex);
      setTimeout(() => setShowStoryModal(true), 100);
    },
    [stories]
  );

  return (
    <>
      {!isSmallScreen && (
        <label
          htmlFor="upload-story"
          className="flex flex-col items-center justify-center cursor-pointer"
        >
          <input
            id="upload-story"
            hidden
            type="file"
            accept={"video/mp4,video/x-m4v,video/*"}
            className="w-full h-full"
            onChange={(e) => {
              setUploadStoryFile(e.target.files[0]);
              setShowStoryModal(true);

              e.target.value = "";
            }}
          />
          <div className="bg-[#1a72d6] flex justify-center items-center w-[90%] rounded cursor-pointer h-8">
            <Add style={{ fontSize: "18px" }} />
            <span className="text-sm text-white text-opacity-80">
              Create Story
            </span>
          </div>
        </label>
      )}
      <div className="w-full flex items-center gap-2 justify-start px-2 mb-8 overflow-hidden py-3">
        {isSmallScreen && (
          <label
            htmlFor="upload-story"
            className="flex flex-col items-center justify-center cursor-pointer"
          >
            <input
              id="upload-story"
              hidden
              type="file"
              accept={"video/mp4,video/x-m4v,video/*"}
              className="w-full h-full"
              onChange={(e) => {
                setUploadStoryFile(e.target.files[0]);
                setShowStoryModal(true);
              }}
            />
            <div className="bg-gray-200 dark:bg-gray-700 flex justify-center items-center w-[60px] h-[60px] rounded-full cursor-pointer h-8">
              <Add
                style={{ fontSize: "23px" }}
                className="text-gray-900 dark:text-white"
              />
            </div>
            <span className="text-sm text-gray-900 dark:text-white text-opacity-80 mt-1">
              Upload
            </span>
          </label>
        )}
        {stories
          ? stories
              .filter((c) => !c.fetched || c.items?.length > 0)
              .map((story) => (
                <StoryItem
                  key={story.id}
                  handleClick={handleStoryItemClick}
                  story={story}
                />
              ))
          : [1, 2, 3, 4].map((story) => <StoryItemShimmer />)}
      </div>
    </>
  );
};

const TutorSidebar = () => {
  const [activePage, setActivePage] = useState("/");
  const [collapse, setCollapse] = useState(false);
  const [visible, setVisible] = useState(true);
  const location = useLocation();
  const [blazeUnreadCount] = useContext(UserContext).blazeUnreadCount;
  const [showDrawer, setShowDrawer] = useContext(UserContext).showDrawer;
  const activeUsersScreen = useContext(UserContext).activeUsersScreen;
  const isTabletScreen = useMediaQuery({ query: "(max-width: 1024px)" });
  const [isDark] = useContext(ThemeContext).theme;

  const [user] = useContext(UserContext).user;
  const [blazeNewMsg, setBlazeNewMsg] = useState(false);

  useEffect(() => {
    if (!blazeUnreadCount) {
      setBlazeNewMsg(false);
      return;
    }
    for (let i in blazeUnreadCount) {
      if (blazeUnreadCount[i] > 0) return setBlazeNewMsg(true);
    }
    return setBlazeNewMsg(false);
  }, [blazeUnreadCount]);

  useEffect(() => {
    const pathName = location.pathname;

    if (pathName.includes("/blaze")) {
      setActivePage("blaze");
      setCollapse(true);
      setVisible(true);
    } else if (pathName === "/earnings") {
      setActivePage("analytics");
      setCollapse(false);
      setVisible(true);
    } else if (pathName === "/") {
      setActivePage("homepage");
      setCollapse(false);
      setVisible(true);
    } else if (pathName === "/resources") {
      setActivePage("resources");
      setCollapse(false);
      setVisible(true);
    } else if (
      pathName === "/classroom" ||
      pathName === "/tips" ||
      pathName === "/practice"
    ) {
      setVisible(false);
    }
  }, [location]);

  return (
    visible && (
      <div
        className={
          collapse || isTabletScreen
            ? "tutor-sidebar collapse"
            : "tutor-sidebar"
        }
        style={{ padding: 0 }}
      >
        <div
          className="tutor-sidebar-list-wrapper"
          style={{ padding: "15px 0px 25px 0px" }}
        >
          <Link to="/">
            <div className="tutuor-sidebar-head pl-[25px]">
              {collapse || isTabletScreen ? (
                <img src={nounBook} alt="pustack logo" draggable={false} />
              ) : (
                <img src={tutorLogo} alt="pustack logo" draggable={false} />
              )}
              {/*<h5>tutor</h5>*/}
            </div>
          </Link>
          {!(collapse || isTabletScreen) && <StoryListItem />}
          <div className="tutuor-sidebar-list pl-[25px]">
            <Link to="/">
              <div
                className={
                  activePage === "homepage"
                    ? "tutor-sidebar-list-item selected"
                    : "tutor-sidebar-list-item"
                }
                style={{ animationDelay: "0.2s" }}
                title="Home"
              >
                <HomeIcon /> <h6>Home</h6>
              </div>
            </Link>
            <Link to="/blaze">
              <div
                className={
                  activePage === "blaze"
                    ? "tutor-sidebar-list-item selected"
                    : "tutor-sidebar-list-item"
                }
                style={{ animationDelay: "0.4s" }}
                title="My Sessions"
              >
                {blazeNewMsg && (
                  <div className="has__sessions">
                    <div className="red__wrapper">
                      <div className="dot__red count blaze" />
                    </div>
                  </div>
                )}
                <VideoCameraRounded /> <h6>My Sessions</h6>
              </div>
            </Link>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                console.log("activeUsersScreen - ", activeUsersScreen);
                setShowDrawer(activeUsersScreen);
              }}
            >
              <div
                className={"tutor-sidebar-list-item"}
                style={{ animationDelay: "0.4s" }}
                title="Outreach"
              >
                <svg
                  style={{ flexShrink: 0 }}
                  xmlns="http://www.w3.org/2000/svg"
                  width={23}
                  height={23}
                  viewBox="0 0 511.92 511.92"
                  fill={"#fff"}
                >
                  <path d="M94.207 270.961H0c2.964 51.719 21.223 100.544 52.607 141.224 17.651-9.969 37.467-18.517 58.874-25.488-10.186-35.589-16.108-74.886-17.274-115.736zM94.207 240.961c1.166-40.851 7.088-80.148 17.275-115.739-21.408-6.97-41.223-15.518-58.874-25.488C21.223 140.415 2.964 189.241 0 240.961zM165.225 71.19c-5.696 10.518-10.839 21.798-15.411 33.713 28.49 6.809 59.317 10.875 91.148 11.848V1.274c-28.023 6.409-54.482 30.665-75.737 69.916zM270.961 1.274V116.75c31.829-.973 62.656-5.04 91.146-11.848-4.573-11.914-9.716-23.195-15.411-33.713-21.255-39.249-47.714-63.505-75.735-69.915zM371.611 133.412c-31.512 7.743-65.581 12.331-100.65 13.35v94.198h116.738c-1.148-38.116-6.656-74.635-16.088-107.548zM120.837 415.148c-17.338 5.647-33.482 12.407-48.072 20.185.631.644 1.25 1.296 1.888 1.934 26.686 26.686 58.224 46.748 92.617 59.399-10.249-11.767-19.783-25.69-28.426-41.65-6.719-12.408-12.727-25.759-18.007-39.868zM391.083 96.772c17.338-5.647 33.482-12.407 48.072-20.184-.631-.644-1.25-1.296-1.888-1.934-26.686-26.686-58.224-46.748-92.617-59.399 10.249 11.767 19.783 25.69 28.426 41.65 6.719 12.407 12.727 25.758 18.007 39.867zM417.714 270.961c-1.166 40.85-7.089 80.147-17.275 115.737 21.408 6.97 41.223 15.518 58.874 25.488 31.385-40.68 49.643-89.505 52.607-141.224h-94.206zM391.083 415.148c-5.28 14.109-11.288 27.459-18.008 39.867-8.642 15.96-18.177 29.883-28.426 41.65 34.393-12.651 65.931-32.713 92.617-59.399.638-.638 1.257-1.29 1.887-1.934-14.589-7.776-30.732-14.537-48.07-20.184zM120.837 96.772c5.28-14.109 11.288-27.459 18.008-39.867 8.642-15.96 18.177-29.883 28.426-41.65-34.393 12.651-65.931 32.713-92.617 59.399-.638.638-1.257 1.29-1.887 1.934 14.589 7.777 30.732 14.537 48.07 20.184zM400.438 125.222c10.187 35.591 16.109 74.888 17.275 115.739h94.207c-2.964-51.72-21.223-100.546-52.607-141.226-17.652 9.969-37.467 18.517-58.875 25.487zM240.961 240.961v-94.198c-35.069-1.019-69.139-5.608-100.652-13.35-9.432 32.912-14.941 69.431-16.088 107.549h116.74zM270.961 270.961v94.196c35.068 1.02 69.138 5.608 100.65 13.35 9.432-32.912 14.94-69.43 16.088-107.547H270.961zM346.695 440.731c5.696-10.518 10.839-21.798 15.411-33.713-28.49-6.809-59.316-10.875-91.146-11.848v115.476c28.022-6.41 54.481-30.666 75.735-69.915zM240.961 510.646V395.17c-31.83.973-62.657 5.039-91.148 11.848 4.573 11.914 9.716 23.195 15.412 33.713 21.255 39.25 47.714 63.506 75.736 69.915zM240.961 270.961h-116.74c1.148 38.117 6.656 74.635 16.088 107.547 31.512-7.743 65.582-12.331 100.652-13.35z" />
                </svg>
                <h6 style={{ paddingLeft: "19px" }}>Outreach</h6>
              </div>
            </a>

            <Link to="/earnings">
              <div
                className={
                  activePage === "analytics"
                    ? "tutor-sidebar-list-item selected"
                    : "tutor-sidebar-list-item"
                }
                style={{ animationDelay: "0.6s" }}
                title="Earnings"
              >
                <h5>₹</h5>
                <h6>Earnings</h6>
              </div>
            </Link>
          </div>
        </div>
      </div>
    )
  );
};

export default TutorSidebar;
